import { render } from "./Card.vue?vue&type=template&id=1fa3d989&scoped=true"
const script = {}

import "./Card.vue?vue&type=style&index=0&id=1fa3d989&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fa3d989"]])

export default __exports__